import z from 'zod'

export const memberChatOpenedSchema = z.object({
  programUuid: z.string(),
})
